import { useEffect, useState } from "react";
import extendDataFetcher from "service/extend-data-fetcher";

const useExtendData = (mode, isLoading, error, data) => {
    const [localData, setLocalData] = useState({});

    useEffect(() => {
        if (!isLoading && !error)
            fetcher(data.data);

        // eslint-disable-next-line
    }, [isLoading, error, data])

    const fetcher = async serviceData => {
        const routes = [
            {
                identifier: "userData",
                url: `/api/identity/user/get?id=${serviceData.user_id}`
            },
            {
                identifier: "subscriptionType",
                url: `/api/financial/subscription/type/get?id=${serviceData.subscription_type_id}`
            }
        ];

        const newData = await extendDataFetcher(routes);
        setLocalData(newData);
    }

    return localData;
}

export default useExtendData;